import React from "react";
import { Filter, } from 'react-admin';

import { ToggleActivityStateFilter } from "components/filters/ToggleActivityStateFilter";
import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { SelectEnumInput } from "../../../components/inputs/SelectEnumInput";

import { UserType } from "entities/UserType";

export const ManagersFilter = props => (
	<Filter {...props}>
		<ToggleActivityStateFilter source="activity_state" defaultValue={null} alwaysOn key={"activity_state"}/>
		<TextInputEx source="_query" alwaysOn />
		<TextInputEx source="first_name" />
		<TextInputEx source="last_name" />
		<SelectEnumInput debounceTime={750} source="type" enumObj={UserType} enumName="user-type" />
		<TextInputEx source="email" />
		<TextInputEx source="phone" />
	</Filter>
);
